<template>
  <div class="distributor-box">
    <!--tab栏区域-->
    <Tabs v-model="tabName" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in tabNameList" :label="item.title" :name="item.value"></TabPane>
    </Tabs>
    <!--功能按钮操作区域-->
    <div class="operation-box">
      <div class="flex align-items-center">
        <!--添加IOSS-->
        <Button v-if="tabName === 'iossManage' && getPermission('ymsIoss_insert')"
          class="mr15" type="primary" @click="$refs['ioss'].initIossData('add')">{{ $t('key1005471') }}</Button>
        <!--添加IOSS-->
        <Button v-if="tabName === 'iossRuleConfig' && getPermission('ymsIossRule_insert')"
          class="mr15" type="primary" @click="$refs['iossRule'].initIossRuleData('add')">{{ $t('key1005441') }}</Button>
        <!--申报说明-->
        <div class="font-size-12">
          <p class="flex align-items-center">
            <span class="redColor">{{ $t('key1005472') }}</span>
            {{ configCharacters() + $t('key1005466') + configCharacters() + $t('key1005467') + configCharacters() + $t('key1005468') }}
            <span class="distributorThemeColor cursor ml3 text-decoration" @click="$refs['viewTaxRates'].initViewTaxRatesData()">{{ $t('key1005473') }}</span>
          </p>
          <p>{{ $t('key1005469') + configCharacters() + $t('key1005470') }}</p>
        </div>
      </div>
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        highlight-row
        border
        max-height="600"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        :draggable="tabName === 'iossRuleConfig' && tableData.length >1"
        @on-drag-drop="dragDrop">
      </Table>
    </div>
    <!--分页区域-->
    <Page
      :transfer="true"
      v-if="!tableLoading"
      :total="total"
      class="distributor-page-box"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <!--日志弹窗-->
    <commonLogModal ref="commonLog" logMode="DISTRIBUTOR" :logType="['SYSTEM_LOG']" :showPage="true"></commonLogModal>
    <!--添加、编辑IOSS弹窗-->
    <iossModal ref="ioss" @updateData="pageParamsStatus = true"></iossModal>
    <!--查看税率弹窗-->
    <viewTaxRatesModal ref="viewTaxRates"></viewTaxRatesModal>
    <!--添加、编辑IOSS规则弹窗-->
    <iossRuleModal
      ref="iossRule"
      :storeAllList="storeAllList"
      :platformList="platformList"
      @updateData="pageParamsStatus = true">
    </iossRuleModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import commonLogModal from "@/components/common/commonLogModal";
import iossModal from "@/views/distributor/components/accountManage/iossModal";
import viewTaxRatesModal from "@/views/distributor/components/accountManage/viewTaxRatesModal";
import iossRuleModal from "@/views/distributor/components/accountManage/iossRuleModal";
import {getAllUsersInfo, getEnabledPlatforms, getUserNameByUserId, setConfigCharacters} from "@/utils/common";

export default {
  name: "iossManageList",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      tabName: 'iossManage',
      tabNameList: [
        {value: 'iossManage', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005450')},
        {value: 'iossRuleConfig', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005451')},
      ],
      pageParams: {
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [],
      iossManageColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005452'),
          key: 'name',
          align: 'left',
          minWidth: 150
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005453'),
          key: 'code',
          align: 'left',
          minWidth: 150,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          align: 'left',
          minWidth: 150,
          render(h, params) {
            let status = params.row.status;
            let text = status === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463');
            return h('span', {class: status === 1 ? 'greenColor' : 'redColor'}, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002476'),
          key: 'updatedBy',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            return h('span', getUserNameByUserId(params.row.updatedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002477'),
          key: 'updatedTime',
          minWidth: 180,
          align: 'left',
          render(h, params) {
            let updatedTime = params.row.updatedTime;
            let time = updatedTime ? v.$uDate.dealTime(updatedTime, 'fulltime') : '-';
            return h('span', time);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'left',
          fixed: 'right',
          key: 'options',
          width: 110,
          render(h, params) {
            let status = params.row.status;
            let ymsIossId = params.row.ymsIossId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsIoss_update'),
                    clickFn: () => {
                      v.$refs['ioss'].initIossData('edit', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['commonLog'].initCommonLogData(ymsIossId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: status === 0 && v.getPermission('ymsIoss_enable'),
                    clickFn: () => {
                      v.enableDisableIossBtn('enable', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status === 1 && v.getPermission('ymsIoss_disable'),
                    color: '#ed4014',
                    clickFn: () => {
                      v.enableDisableIossBtn('disable', params.row);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      iossRuleConfigColumns: [
        {
          title: 'No.',
          key: 'index',
          width: 65,
          align: 'center',
          type: 'index'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002152'),
          width: 140,
          align: 'left',
          render(h, params) {
            let arr = [
              h('span', {
                attrs: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002153')},
                domProps: {innerHTML: '&#xe670;'},
                class: 'icon iconfont cursor greenColor',
                style: {
                  fontSize: '18px',
                  margin: '0 4px'
                },
                on: {
                  click: () => {
                    v.tableSort(params.row.autoRuleId, v.tableData.length - 1, params.index);
                  }
                }
              }),
              h('span', {
                attrs: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002154')},
                domProps: {innerHTML: '&#xe63c;'},
                class: 'icon iconfont cursor blueColor',
                style: {
                  fontSize: '18px',
                  margin: '0 4px'
                },
                on: {
                  click: () => {
                    v.tableSort(params.row.autoRuleId, 0, params.index);
                  }
                }
              }),
              h('Icon', {
                props: {type: 'md-move', size: 20},
                attrs: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002155')},
                style: {
                  marginLeft: '5px',
                  position: 'relative',
                  top: '-2px'
                },
                class: 'cursor-move grayColor'
              })
            ];
            if (params.index === 0) {
              arr.splice(1, 1);
            } else if (params.index === v.tableData.length - 1) {
              arr.splice(0, 1);
            }
            if (v.tableData.length > 1) {
              return v.getPermission('ymsIossRule_updatePriority') ? h('div', {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }
              }, arr) : '';
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002156'),
          key: 'name',
          align: 'left',
          minWidth: 150,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005454'),
          key: 'iossName',
          align: 'left',
          minWidth: 140,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005455'),
          key: 'iossCode',
          align: 'left',
          minWidth: 120,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          align: 'left',
          minWidth: 90,
          render(h, params) {
            let status = params.row.status;
            let text = status === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463');
            return h('span', {class: status === 1 ? 'greenColor' : 'redColor'}, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005456'),
          key: 'platformsOrStores',
          align: 'left',
          minWidth: 320
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002476'),
          key: 'updatedBy',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            return h('span', getUserNameByUserId(params.row.updatedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002477'),
          key: 'updatedTime',
          minWidth: 170,
          align: 'left',
          render(h, params) {
            let updatedTime = params.row.updatedTime;
            let time = updatedTime ? v.$uDate.dealTime(updatedTime, 'fulltime') : '-';
            return h('span', time);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'left',
          fixed: 'right',
          key: 'options',
          width: 150,
          render(h, params) {
            let status = params.row.status;
            let autoRuleId = params.row.autoRuleId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsIossRule_update'),
                    clickFn: () => {
                      v.$refs['iossRule'].initIossRuleData('edit', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['commonLog'].initCommonLogData(autoRuleId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: status === 0 && v.getPermission('ymsIossRule_enable'),
                    clickFn: () => {
                      v.enableDisableIossRuleBtn('enable', autoRuleId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status === 1 && v.getPermission('ymsIossRule_disable'),
                    color: '#ed4014',
                    clickFn: () => {
                      v.enableDisableIossRuleBtn('disable', autoRuleId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      storeAllList: [],
      platformList: [],
      userInfoList:{}
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
        });
        await this.getStoreAllData();
        await getEnabledPlatforms().then((data) => {
          if (data && data.length > 0) {
            this.platformList = data.concat([{platformId: 'other', name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005449')}`}]);
          }
        });
        await this.showIossRuleModal();
        await this.getList();
      })();
    },
    // 根据配置是否弹窗添加IOSS弹窗
    showIossRuleModal() {
      let openIossConfig = localStorage.getItem('openIossConfig') ? JSON.parse(localStorage.getItem('openIossConfig')) : false;
      if (openIossConfig) {
        this.$refs['ioss'].initIossData('add');
        setTimeout(() => {
          localStorage.removeItem('openIossConfig');
        }, 500);
      }
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      switch (v.tabName) {
        case 'iossManage':
          v.tableColumns = v.iossManageColumns;
          if (v.getPermission('ymsIoss_query')) {
            v.tableLoading = true;
            v.axios.post(api.post_ymsIoss_query, v.pageParams).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas;
                v.tableData = data.list || [];
                v.total = data.total;
                v.$nextTick(() => {
                  v.tableLoading = false;
                });
              } else {
                v.tableLoading = false;
              }
            });
          } else {
            v.gotoError();
          }
          break;
        case 'iossRuleConfig':
          v.tableColumns = v.iossRuleConfigColumns;
          if (v.getPermission('ymsIossRule_query')) {
            v.tableLoading = true;
            v.axios.post(api.post_ymsIossRule_query, v.pageParams).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas;
                let newList = data.list || [];
                v.handleIossRuleList(newList);
                v.total = data.total;
                v.$nextTick(() => {
                  v.tableLoading = false;
                });
              } else {
                v.tableLoading = false;
              }
            });
          } else {
            v.gotoError();
          }
          break;
      }
    },
    // 处理IOSS规则列表数据
    handleIossRuleList(newList) {
      let v = this;
      let ymsIossIdList = [];
      if (newList.length > 0) {
        newList.map((item) => {
          let platformsOrStoresList = [];
          let ruleActions = item.ruleActions || [];
          let ruleItems = item.ruleItems || [];
          if (ruleActions.length > 0) {
            ruleActions.map((ele) => {
              if (ele.type === 'IOSS_CONFIG_RULE') {
                let obj = JSON.parse(ele.value);
                if (obj.ymsIossId) {
                  ymsIossIdList.push(obj.ymsIossId);
                  item.ymsIossId = obj.ymsIossId || null;
                }
              }
            });
          }
          if (ruleItems.length > 0) {
            ruleItems.map((ele) => {
              if (ele.ruleCode === 'IOSS_CONFIG_RULE') {
                let ruleItemParams = ele.ruleItemParams || [];
                if (ruleItemParams.length > 0) {
                  let ruleItemParamValues = ruleItemParams[0].ruleItemParamValues || [];
                  let name = ruleItemParams[0].name;
                  if (ruleItemParamValues.length > 0) {
                    ruleItemParamValues.map((talg) => {
                      let obj = JSON.parse(talg.value);
                      // 店铺
                      if (name === 'shopIds') {
                        v.storeAllList.map((k) => {
                          if (k.ymsPlatformAccountId === obj.shopId) {
                            let name = k.platformId + '-' + k.code;
                            platformsOrStoresList.push(name);
                          }
                        });
                        item.platformsOrStores = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005457') + '=' + platformsOrStoresList.join('、');
                      }
                      // 平台
                      else {
                        v.platformList.map((j) => {
                          if (j.platformId === obj.platformId) {
                            platformsOrStoresList.push(j.name);
                          }
                        });
                        item.platformsOrStores = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005419') + '=' + platformsOrStoresList.join('、');
                      }
                    });
                  }
                }
              }
            });
          }
        });
        ymsIossIdList = v.uniqueFunc(ymsIossIdList);
        if (ymsIossIdList.length > 0) {
          v.axios.post(api.post_ymsIoss_queryIossByIds, ymsIossIdList).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas || [];
              if (data.length > 0) {
                newList.map((item) => {
                  data.map((ele) => {
                    if (item.ymsIossId === ele.ymsIossId) {
                      item.iossName = ele.name;
                      item.iossCode = ele.code;
                    }
                  });
                });
                v.tableData = newList;
                v.$forceUpdate();
              }
            }
          });
        }
      }
    },
    // 切换Tab栏
    changeTab() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 启用、停用IOSS
    enableDisableIossBtn(type, data) {
      let v = this;
      let title = type === 'enable' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005458') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005459');
      let content = type === 'enable' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005460') :
        aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005461');
      let okText = type === 'enable' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002483') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002484');
      let text = type === 'enable' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002485') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002486');
      let url = type === 'enable' ? api.put_ymsIoss_enable : api.put_ymsIoss_disable;
      v.$Modal.confirm({
        title: title,
        content: content,
        okText: okText,
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          if (type === 'enable') {
            v.axios.put(url + data.ymsIossId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(text);
                v.pageParamsStatus = true;
              }
            });
          } else {
            let query = {
              autoRuleIds: data.autoRuleIds,
              ymsIossId: data.ymsIossId
            };
            v.axios.put(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(text);
                v.pageParamsStatus = true;
              }
            });
          }
        },
        onCancel: () => {
        }
      });
    },
    // 启用、调用IOSS规则
    enableDisableIossRuleBtn(type, autoRuleId) {
      let v = this;
      let title = type === 'enable' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005462') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005463');
      let content = type === 'enable' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005464') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005465');
      let okText = type === 'enable' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002483') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002484');
      let text = type === 'enable' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002485') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002486');
      let url = type === 'enable' ? api.put_ymsIossRule_enable : api.put_ymsIossRule_disable;
      v.$Modal.confirm({
        title: title,
        content: content,
        okText: okText,
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.put(url + autoRuleId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(text);
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },

    // 优先级拖拽排序
    dragDrop(a, b) {
      this.tableSort(this.tableData[a].autoRuleId, b, a);
    },
    // 处理拖拽排序
    tableSort(autoRuleId, index, oldIndex) {
      let v = this;
      let obj = {
        currentId: autoRuleId, // 规则ID
        previousId: index ? v.tableData[index].autoRuleId : null, // 前一个
        businessId: v.tableData[oldIndex].businessId
      };
      if (!index && v.tableData.length > 1) {
        obj.nextId = v.tableData[0].autoRuleId;
      }
      if (oldIndex > index) {
        obj = {
          currentId: v.tableData[oldIndex].autoRuleId, // 规则ID
          businessId: v.tableData[oldIndex].businessId,
          previousId: index > 0 ? v.tableData[index - 1].autoRuleId : null
        };
        if (index >= 0 && index !== v.tableData.length - 1) {
          obj.nextId = v.tableData[index + 1].autoRuleId;
        }
      } else {
        obj = {
          currentId: v.tableData[oldIndex].autoRuleId, // 规则ID
          businessId: v.tableData[oldIndex].businessId,
          previousId: index > 0 ? v.tableData[index].autoRuleId : null
        };
        if (index >= 0 && index !== v.tableData.length - 1) {
          obj.nextId = v.tableData[index + 1].autoRuleId;
        }
      }
      v.axios.put(api.put_ymsIossRule_updatePriority, JSON.stringify(obj),
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.getList();
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
        }
      });
    },
    // 获取所有店铺数据
    getStoreAllData() {
      let v = this;
      v.axios.post(api.post_ymsPlatformAccount_queryAll).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            data.map((item) => {
              item.storeName = item.platformId + '-' + item.code;
              item.storeId = item.platformId + '-' + item.ymsPlatformAccountId;
            });
            v.storeAllList = data;
          }
        }
      });
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    commonLogModal,
    iossModal,
    viewTaxRatesModal,
    iossRuleModal
  }
};
</script>

<style lang="less" scoped>

</style>